// import React, { useState } from "react";
// import "./Navbar.css";
// import MobileSidebar from "./MobileSidebar";

// const categories = [
//   {
//     name: "Rings",
//     items: [
//       { name: "Types", subItems: ["Solitaire", "Halo", "Vintage"] },
//       { name: "By Metal", subItems: ["Gold", "Platinum", "Rose Gold"] },
//       { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
//     ],
//     images: ["https://spinellejewelry.com/cdn/shop/files/C111116SKCH2025986_wt-5-10_-1.jpg?v=1721813379&width=450", "https://spinellejewelry.com/cdn/shop/files/HYLR1223_2.jpg?v=1716524365&width=450"]
//   },



//   {
//     name: "Earrings",
//     items: [
//       { name: "Types", subItems: ["Studs", "Drops & Danglers", "Hoops & Huggies", "Pearl Earrings"] },
//       { name: "By Metal", subItems: ["Gold", "Platinum"] },
//          { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
//     ],
//     images: ["https://spinellejewelry.com/cdn/shop/files/HYER625_4.jpg?v=1721713566&width=450", "https://spinellejewelry.com/cdn/shop/files/ST-25043-ERRose3.jpg?v=1724931198&width=450"]
//   },

//   {
//     name: "Pendants",
//     items: [
//       { name: "Types", subItems: ["Alphabet", "Heart", "Religious"] },
//       { name: "By Metal", subItems: ["Gold", "Diamond", "Platinum"] },
//          { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
//     ],
//     images: ["https://spinellejewelry.com/cdn/shop/files/83APPYL.jpg?v=1743056575&width=450", "https://spinellejewelry.com/cdn/shop/files/solitaire-super-light-weight-earring-pendant-set-3d-model-5776621bc0.jpg?v=1742276128&width=450"]
//   },

//   {
//     name: "Necklace",
//     items: [
//       { name: "Types", subItems: ["Choker", "Layered", "Statement"] },
//       { name: "Occasion", subItems: ["Wedding", "Party", "Daily Wear"] },
//          { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
//     ],
//     images: ["https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-925c99a5d0.jpg?v=1716624902&width=750", "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-f57570f68c.jpg?v=1716624283&width=450"]
//   },
//   {
//     name: "Kids Jewellery",
//     items: [
//       { name: "Types", subItems: ["Earrings", "Pendants", "Bracelets"] },
//       { name: "Material", subItems: ["Gold", "Silver"] },
//          { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
//     ],
//     images: ["https://spinellejewelry.com/cdn/shop/files/women-stud-earrings-3dm-stl-obj-fbx-renders-details-3d-model-7dadb802b4.jpg?v=1742810556&width=450", "https://spinellejewelry.com/cdn/shop/files/women-studs-heart-earrings-3dm-stl-obj-fbx-renders-details-3d-model-57443dcc9b.jpg?v=1742809766&width=450"]
//   },

// ];


// const Navbar = () => {
//   const [hovered, setHovered] = useState(null);


//   const [mobileCategory, setMobileCategory] = useState(null);


//    const handleMobileClick = (index) => {
//     setMobileCategory(categories[index]);
//   };


//   return (
//     <nav className="navbar" onMouseLeave={() => setHovered(null)}>
// <ul className="navbar-list">
//   {categories.map((cat, index) => (
//     <li
//       key={index}
//       className="navbar-item"
//       onMouseEnter={() => setHovered(index)}
//     >
//       <span>{cat.name}</span>
//     </li>
//   ))}
// </ul>

// {/* Mobile scrollable categories */}
//   <div className="navbar-scroll">
//         {categories.map((cat, index) => (
//           <div
//             key={index}
//             className="navbar-scroll-item"
//             onClick={() => handleMobileClick(index)}
//           >
//             <img src={cat.images[0]} alt={cat.name} />
//             <span>{cat.name}</span>
//           </div>
//         ))}
//       </div>

//       {hovered !== null && (
//         <div
//           className="dropdown"
//           onMouseEnter={() => setHovered(hovered)}
//           onMouseLeave={() => setHovered(null)}
//         >
//           <div className="dropdown-content">
//             <div className="dropdown-columns">
//               {categories[hovered].items.map((item, idx) => (
//                 <div key={idx} className="dropdown-column">
//                   <h4>{item.name}</h4>
//                   <ul>
//                     {item.subItems.map((sub, subIdx) => (
//                       <li key={subIdx}>{sub}</li>
//                     ))}
//                   </ul>
//                 </div>
//               ))}
//             </div>
//             <div className="dropdown-images">
//               {categories[hovered].images.map((src, idx) => (
//                 <img key={idx} src={src} alt="preview" />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//   <MobileSidebar
//   key={mobileCategory?.name} // ← forces re-mount on new category
//   category={mobileCategory}
//   onClose={() => setMobileCategory(null)}
// />

//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from "react";
import "./Navbar.css";
import MobileSidebar from "./MobileSidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [categories, setCategories] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [hovered, setHovered] = useState(null);
  const [mobileCategory, setMobileCategory] = useState(null);
   const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const [catRes, typeRes] = await Promise.all([
        axios.get("https://spinelleapi.emedha.in/home/page/api/categories"),
        axios.get("https://spinelleapi.emedha.in/home/page/api/product-types")
      ]);

      // Static fallback for each category
      const imagesMap = {
        "Rings": [
          "https://spinellejewelry.com/cdn/shop/files/C111116SKCH2025986_wt-5-10_-1.jpg?v=1721813379&width=450",
          "https://spinellejewelry.com/cdn/shop/files/HYLR1223_2.jpg?v=1716524365&width=450"
        ],
        "Earrings": [
          "https://spinellejewelry.com/cdn/shop/files/HYER625_4.jpg?v=1721713566&width=450",
          "https://spinellejewelry.com/cdn/shop/files/ST-25043-ERRose3.jpg?v=1724931198&width=450"
        ],
        "Pendants": [
          "https://spinellejewelry.com/cdn/shop/files/83APPYL.jpg?v=1743056575&width=450",
          "https://spinellejewelry.com/cdn/shop/files/solitaire-super-light-weight-earring-pendant-set-3d-model-5776621bc0.jpg?v=1742276128&width=450"
        ],
        "Necklace": [
          "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-925c99a5d0.jpg?v=1716624902&width=750",
          "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-f57570f68c.jpg?v=1716624283&width=450"
        ],
        "Kids Jewellery": [
          "https://spinellejewelry.com/cdn/shop/files/women-stud-earrings-3dm-stl-obj-fbx-renders-details-3d-model-7dadb802b4.jpg?v=1742810556&width=450",
          "https://spinellejewelry.com/cdn/shop/files/women-studs-heart-earrings-3dm-stl-obj-fbx-renders-details-3d-model-57443dcc9b.jpg?v=1742809766&width=450"
        ]
      };

      // Merge categories and types
      const enrichedCategories = catRes.data.map((cat) => {
        const matchingTypes = typeRes.data
          .filter((type) => type.category_id === cat.id)
          .map((t) => t.name);

        return {
          name: cat.name,
          items: [
            { name: "Types", subItems: matchingTypes },
            { name: "By Metal", subItems: ["Gold", "Platinum", "Rose Gold"] },
            { name: "By Price", subItems: ["Under ₹10k", "₹10k–₹50k", "Above ₹50k"] }
          ],
          images: imagesMap[cat.name] || []
        };
      });

      setCategories(enrichedCategories);
      setProductTypes(typeRes.data);
    };

    fetchData();
  }, []);

  const handleMobileClick = (index) => {
    setMobileCategory(categories[index]);
  };

    const handleCategoryChange = () => {

    navigate('/products');
  };

  return (
    <nav className="navbar" onMouseLeave={() => setHovered(null)}>
      <ul className="navbar-list">
        {categories.map((cat, index) => (
          <li
            key={index}
            className="navbar-item"
            onMouseEnter={() => setHovered(index)}
             onClick={() => handleCategoryChange(cat.name)}
          >
            <span>{cat.name}</span>
          </li>
        ))}
      </ul>

      {/* Mobile Scrollable */}
      <div className="navbar-scroll">
        {categories.map((cat, index) => (
          <div
            key={index}
            className="navbar-scroll-item"
            onClick={() => handleMobileClick(index)}
          >
            <img src={cat.images[0]} alt={cat.name} />
            <span>{cat.name}</span>
             
          </div>
        ))}
      </div>

      {/* Desktop Dropdown */}
      {hovered !== null && (
        <div
          className="dropdown"
          onMouseEnter={() => setHovered(hovered)}
          onMouseLeave={() => setHovered(null)}
        >
          <div className="dropdown-content">
            <div className="dropdown-columns">
              {categories[hovered].items.map((item, idx) => (
                <div key={idx} className="dropdown-column">
                  <h4>{item.name}</h4>
                  <ul>
                    {item.subItems.map((sub, subIdx) => (
                      <li key={subIdx}>{sub}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="dropdown-images">
              {categories[hovered].images.map((src, idx) => (
                <img key={idx} src={src} alt="preview" />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Mobile Sidebar */}
      <MobileSidebar
        key={mobileCategory?.name}
        category={mobileCategory}
        onClose={() => setMobileCategory(null)}
      />
    </nav>
  );
};

export default Navbar;
